<template>
  <n-config-provider :theme="themeStore.themeValue()">
    <n-message-provider>
      <n-dialog-provider>
        <n-notification-provider>
          <LayoutDefault />
        </n-notification-provider>
      </n-dialog-provider>
    </n-message-provider>
  </n-config-provider>
</template>

<script setup>
import { watch } from 'vue'
import { useThemeStore } from './components/themeStore'
import LayoutDefault from './components/LayoutDefault.vue'

const themeStore = useThemeStore()

watch(
  () => themeStore.isDark,
  (dark) => {
    document.body.className = dark ? 'dark' : 'light'
  },
  { immediate: true }
)
</script>

